import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../Context/ThemeContext';
import { showDatePicker } from '../../Components/Common/StyledTextField';
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from '../../Utils/constants';
import {
    Box,
    Grid,
    Typography,
    IconButton,
    InputBase,
    Autocomplete,
    TextField,
} from '@mui/material';
import ConfirmationModal from '../../Components/Common/ConfirmationModal';
import SuccessNotification from '../../Components/Common/SuccessNotification';
import LoadingAnimation from '../../Components/Common/LoadingAnimation';
import WestIcon from '@mui/icons-material/West';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { FileUpload } from './FileUpload';
import { addFranchise, deleteFranchise, getFranchise, updateFranchise } from '../../Services/authService';
import ArrowButton from '../../Components/Common/ArrowButton';
import DeleteConfirmationPopup from '../../Components/Common/DeleteConfirmationPopup';
import countryCodes from '../../Components/Layouts/full_country_calling_codes.json';
import './Franchise.css'
import useMediaQuery from '@mui/material/useMediaQuery';

function FranchiseModal() {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { mode } = useThemeContext();
    const franchiseId = location.state?.id || null;
    const mode1 = location.state?.mode || "add";

    const initialFormState = {
        name: "",
        businessType: "",
        userName: "",
        email: "",
        phoneNumber: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        startDate: "",
        endDate: "",
        active: true
    };
    const [countryCode, setCountryCode] = useState({ name: "Germany", dial_code: "+49" });
    const [phoneNumber, setPhoneNumber] = useState('');
    const [hasMachines, setHasMachines] = useState(false);
    const [deleteErrorMessage, setDeleteErrorMessage] = useState('');

    const [formData, setFormData] = useState(initialFormState);
    const [formData1, setFormData1] = useState(initialFormState);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null); // File object for the image
    const [errors, setErrors] = useState({}); // Validation errors
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false); // Tracks if the form is modified
    const [isLoading, setIsLoading] = useState(false);
    const [successNotification, setSuccessNotification] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [agreementFile, setAgreementFile] = useState(null);
    const [termsConditionsFile, setTermsConditionsFile] = useState(null);
    const [invoiceDocumentFile, setInvoiceDocumentFile] = useState(null);
    const [existingAgreementDocumentUrl, setExistingAgreementDocumentUrl] = useState(null);
    const [existingtermsConditionsUrl, setExistingtermsConditionsUrl] = useState(null);
    const [existinginvoiceDocumentUrl, setExistinginvoiceDocumentUrl] = useState(null);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);

    const backgroundCard = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const cardBorderColor = mode === 'dark' ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale30;
    const inputBoxColor = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const textColor1 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const errorTextColor = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setErrors({})
        if (franchiseId && mode1 === "update") {
            // console.log(t("franchise.fetchingFranchiseData"), franchiseId);
            fetchFranchiseData(franchiseId);
        }
    }, [franchiseId, mode1]);  // Only runs when franchiseId or mode1 changes

    const fetchFranchiseData = async (id) => {
        try {
            setIsLoading(true);
            const response = await getFranchise(id); // API call
            const data = {
                id: response?.id,
                name: response?.name,
                businessType: response?.businessType,
                // userName: response?.userName,
                email: response?.email,
                phoneNumber: response?.phoneNumber,
                addressLine1: response?.addressLine1,
                addressLine2: response?.addressLine2,
                city: response?.city,
                state: response?.state,
                country: response?.country,
                zipCode: response?.zipCode,
                startDate: response?.startDate,
                endDate: response?.endDate,
                active: response?.active,
                numberOfMachinesOwned: response?.numberOfMachinesOwned
            }
            if (data?.phoneNumber) {
                const matched = countryCodes.find(c => data.phoneNumber.startsWith(c.dial_code));
                if (matched) {
                    setCountryCode(matched);
                    setPhoneNumber(data.phoneNumber.replace(matched.dial_code, '').trim());
                } else {
                    setPhoneNumber(data.phoneNumber);
                }
            }
            setFormData(data)
            setFormData1(data)
            setExistingAgreementDocumentUrl(response?.contractUrl || null)
            setExistingtermsConditionsUrl(response?.termsUrl || null)
            setExistinginvoiceDocumentUrl(response?.invoiceUrl || null)
            setImagePreview(response?.logoUrl)
        } catch (error) {
            console.error(t("franchise.errorFetchingFranchise"), error);
            setErrors({ apiError: t("franchise.failedFetchFranchiseDetails") });
        } finally {
            setIsLoading(false);
        }
    };

    // Watch for changes to form data to track dirty state
    useEffect(() => {
        if (mode1 === 'add')
            setIsDirty(JSON.stringify(initialFormState) !== JSON.stringify(formData));
        else
            setIsDirty(JSON.stringify(formData) !== JSON.stringify(formData1));
    }, [formData, initialFormState, mode1]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setErrors({});
    };

    const validate = () => {
        let tempErrors = {};
        if (!formData.name.trim()) tempErrors.name = t('taxes.CompanyName');
        if (!formData.businessType.trim()) tempErrors.businessType = t('franchise.BusinessType');
        if (!phoneNumber) tempErrors.phoneNumber = t('membershipCards.Mobilenumberrequired');
        else if (!/^\d{5,15}$/.test(phoneNumber)) tempErrors.phoneNumber = t('membershipCards.phoneNumberMustBe5to15');
        if (!formData.email) {
            tempErrors.email = t('membershipCards.Emailisrequired');
        } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
            tempErrors.email = t('membershipCards.Invalidemail');
        }
        if (mode1 === 'add') {
            if (!formData.userName.trim()) tempErrors.userName = t('loginPage.requiredUsername');
        }
        if (!formData.addressLine1) tempErrors.addressLine1 = t('membershipCards.Addressisrequired');
        if (!formData.city) tempErrors.city = t('membershipCards.Cityisrequired');
        if (!formData.state) tempErrors.state = t('membershipCards.Stateisrequired');
        if (!formData.country) tempErrors.country = t('taxes.Countryisrequired');
        if (!formData.zipCode) tempErrors.zipCode = t('vendingMachines.Zipcode');
        else if (!/^\d{5,6}$/.test(formData.zipCode)) tempErrors.zipCode = t('vendingMachines.Zipcodemust');

        // End Date Validation
        if (formData.startDate && formData.endDate && new Date(formData.endDate) < new Date(formData.startDate)) {
            tempErrors.endDate = t('franchise.EndDatenotearlier');
        }

        // Surface a single top-level message when any required field is missing
        if (Object.keys(tempErrors).length > 0) {
            tempErrors.apiError = t('navbar.fillAllRequiredFields');
        }
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleBackClick = () => {
        if (isDirty) {
            setIsModalOpen(true); // Open the modal only if the form is modified
        } else {
            navigate(ROUTES.FRANCHISE)
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false); // Close the modal
    };

    const handleSaveChanges = () => {
        setIsModalOpen(false); // Close the modal after saving
        handleSubmit();
    };

    const handleDiscardChanges = () => {
        setIsModalOpen(false); // Close the modal after discarding
        navigate(ROUTES.FRANCHISE)
    };

    const handleSubmit = async () => {
        if (validate()) {
            try {
                if (mode1 === "update") {
                    // Files live outside formData, so an upload alone also counts as a
                    // change. Documents already on record (from a previous submission)
                    // count as uploaded too — saving must never force re-uploading them.
                    const hasExistingDocuments = existingAgreementDocumentUrl || existingtermsConditionsUrl || existinginvoiceDocumentUrl;
                    if (!isDirty && !imageFile && !agreementFile && !termsConditionsFile && !invoiceDocumentFile && !hasExistingDocuments) {
                        setErrors({ apiError: t('vendingMachines.Pleaseupdate') });
                        return;
                    }
                }
                setIsLoading(true);
                // Create FormData object
                const formDataToSend = new FormData();
                formDataToSend.append("franchise", JSON.stringify(formData));
                if (imageFile) formDataToSend.append("logo", imageFile);
                if (agreementFile) formDataToSend.append("contract", agreementFile);
                if (termsConditionsFile) formDataToSend.append("terms", termsConditionsFile);
                if (invoiceDocumentFile) formDataToSend.append("invoice", invoiceDocumentFile);

                // console.log(t("franchise.debugFormData"), JSON.stringify(formDataToSend));

                // Conditional API call
                if (mode1 === "add") {
                    await addFranchise(formDataToSend);
                } else if (mode1 === "update") {
                    await updateFranchise(formData.id, formDataToSend);
                }

                setIsLoading(false);
                setSuccessMessage(mode1 === 'add' ? t('franchise.successMessage') : t('franchise.successMessage1'));
                setSuccessNotification(true); // Show success notification
                // Add delay to show the notification before navigating
                setTimeout(() => {
                    navigate(ROUTES.FRANCHISE);
                }, 3000); // 3-second delay
            } catch (error) {
                setIsLoading(false);

                let errorMessage = 'An unexpected error occurred. Please try again.';

                if (error.response) {
                    const data = error.response.data;
                    if (typeof data === 'string') {
                        errorMessage = data;
                    } else if (typeof data?.detail === 'string') {
                        errorMessage = data.detail;
                    } else if (typeof data?.error === 'string') {
                        errorMessage = data.error;
                    } else if (data?.message) {
                        errorMessage = data.message;
                    } else if (Array.isArray(data?.errors)) {
                        errorMessage = data.errors.map(err => err.message || '').join(', ');
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }

                setErrors({ apiError: errorMessage });
            }
        }
    };

    // Handle Image Selection
    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file type
            const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!validImageTypes.includes(file.type)) {
                setErrors({ ...errors, image: t('vendingMachines.Pleaseupload') });
                return;
            }

            // Generate image preview
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreview(reader.result); // Set the image preview
                setErrors({ ...errors, image: '' }); // Clear image errors
            };
            reader.readAsDataURL(file);
            setImageFile(file);
        }
    };

    const handleFileUpload1 = (file, errorMessage) => {
        setAgreementFile(file);
        setErrors((prevErrors) => ({
            ...prevErrors,
            agreementDocument: errorMessage,
        }));
    };

    const handleFileUpload2 = (file, errorMessage) => {
        setTermsConditionsFile(file);
        setErrors((prevErrors) => ({
            ...prevErrors,
            termsConditions: errorMessage,
        }));
    };

    const handleFileUpload3 = (file, errorMessage) => {
        setInvoiceDocumentFile(file);
        setErrors((prevErrors) => ({
            ...prevErrors,
            invoiceDocument: errorMessage,
        }));
    };

    const handleDeleteClick = () => {
        if (formData.numberOfMachinesOwned > 0) {
            setDeleteErrorMessage(t('franchise.cannotDeleteWithMachines')); // set your i18n key
            setHasMachines(true);
        } else {
            setDeleteErrorMessage('');
            setHasMachines(false);
        }
        setIsDeletePopupOpen(true);
    };

    const handleCloseDeletePopup = () => {
        setIsDeletePopupOpen(false);
    };

    const handleConfirmDelete = async () => {
        // console.log(t("franchise.deletingFranchiseId"), franchiseId);
        if (!franchiseId) return;
        // console.log(t("franchise.confirmingFranchiseDeletion"), franchiseId);

        try {
            setIsLoading(true)
            await deleteFranchise(franchiseId); // Call the delete API
            setSuccessMessage(t('franchise.successMessage2'));
            setSuccessNotification(true);
            setIsDeletePopupOpen(false);
            setTimeout(() => {
                navigate(ROUTES.FRANCHISE)
            }, 3000);
        } catch (error) {
            // setErrorMessage(`Failed to delete Product.`);
        } finally {
            setIsLoading(false)
        }
    };

    const onlyPositiveNumberProps = {
        inputProps: {
            min: 0,
            inputMode: 'decimal',
            pattern: '[0-9]*[.,]?[0-9]*', // optional dot/comma for decimal
        },
        onKeyDown: (e) => {
            const allowed = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];
            const isNumber = /^\d$/.test(e.key);
            const isDot = e.key === '.';
            const alreadyHasDot = e.target.value.includes('.');

            if (!isNumber && !allowed.includes(e.key)) {
                if (isDot && !alreadyHasDot) {
                    // Allow a single decimal point
                    return;
                }
                e.preventDefault();
            }
        },
        onPaste: (e) => {
            const pasted = e.clipboardData.getData('text');
            if (!/^\d*\.?\d*$/.test(pasted)) {
                e.preventDefault(); // Block non-decimal or negative values
            }
        }
    };
    const isTablet = useMediaQuery('(max-width:900px)');
    const isMobile = useMediaQuery('(max-width:500px)');

    return (
        <div className="main-container">
            {isLoading && <LoadingAnimation />}
            {/* Back Button */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    sx={{
                        color: btnColor,
                        backgroundColor: backgroundCard,
                        padding: '0.6rem',
                        borderRadius: '50%',
                        marginRight: '1rem',
                        '&:hover': { backgroundColor: backgroundCard },
                    }}
                    onClick={handleBackClick}
                >
                    <WestIcon fontSize="small" />
                </IconButton>
                <h2 className="addmachine-text-heading">{t('franchise.back')}</h2>
            </Box>

            <Box sx={{ background: backgroundCard, p: isMobile ? 1.5 : 3, margin: "20px 0px", borderRadius: "12px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Back Button and Title */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <h2 className="addmachine-text-heading">
                            {franchiseId ? t('franchise.editFrachise') : t('franchise.addNewFranchise')}
                        </h2>
                    </Box>
                    {/* Save Button */}
                    <button type="button" onClick={handleSubmit} style={{ background: btnColor, cursor: "pointer" }} className='save-btn'>{t('membershipCards.save')}</button>
                </Box>

                {/* Error Message */}
                {errors.apiError && (
                    <Typography sx={{ color: errorTextColor, fontSize: '15px', marginBottom: '12px', textAlign: "center" }}>
                        {errors.apiError}
                    </Typography>
                )}

                {/* First Layout */}
                <div className='card-border-sec' style={{
                    position: "relative", borderRadius: "8px",
                    border: `1px solid ${cardBorderColor}`, margin: "4rem 0rem 2rem"
                }}>
                    {/* General Text */}
                    <h3
                        className='subheading-sec-card'
                        style={{
                            position: "absolute",
                            top: "-10px",
                            left: "15px",
                            backgroundColor: backgroundCard,
                            padding: "0 10px",
                        }}
                    >
                        {t('franchise.general')}
                    </h3>

                    <Grid className='franchise-profile-section' container spacing={isTablet ? 2 : 10} sx={{
                        padding: '3rem 2rem',
                        '@media (max-width: 1060px)': {
                            padding: '1rem 0.5rem',
                        }
                    }} >
                        {/* Left Section */}
                        <Grid item xs={12} sm={6} md={4} className='stategrid2'>
                            {/* Image Upload */}
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    // position: 'relative',
                                    width: '100%',
                                    height: '100px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                }}
                                onClick={() => document.getElementById('upload-image').click()}
                            >
                                <input
                                    type="file"
                                    id="upload-image"
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                />
                                {imagePreview ? (
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                        }}
                                    />
                                ) : (
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <AddPhotoAlternateIcon
                                            sx={{
                                                fontSize: '4rem',
                                                color: '#C6C6C6',
                                            }}
                                        />
                                        <Typography sx={{ color: textColor1 }}>
                                            {t('franchise.UploadImage')}
                                        </Typography>
                                    </div>
                                )}
                            </Box>
                        </Grid>

                        {/* Middle Section */}
                        <Grid item xs={12} sm={6} md={4} className='stategrid5 '>
                            {/* Company Name */}
                            <p className='label-text-sec'>{t('franchise.CompanyName')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder={t('franchise.CompanyName')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.name && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.name}
                                </Typography>
                            )}
                        </Grid>

                        {/* Right Section */}
                        <Grid item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* Business type */}
                            <p className='label-text-sec'>{t('franchise.Businesstype')}*</p>
                            {/* <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <FormControl fullWidth>
                                    <Select
                                        name="businessType"
                                        className='select'
                                        value={formData.businessType}
                                        onChange={handleChange}
                                        displayEmpty
                                        sx={{
                                            fontSize: '14px',
                                            color: textColor,
                                            backgroundColor: inputBoxColor,
                                            boxShadow: 'none',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: 'none',
                                            },
                                            '& .MuiSelect-select': {
                                                padding: '0',
                                                height: '34px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            },
                                            '& .MuiSelect-icon': {
                                                color: '#9CA3AF',
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            {t('franchise.Typeofbusiness')}
                                        </MenuItem>
                                        <MenuItem value="Hardware">{t('franchise.Hardware')}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box> */}

                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="businessType"
                                    value={formData.businessType}
                                    onChange={handleChange}
                                    placeholder={t('franchise.Businesstype')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.businessType && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.businessType}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </div>

                {/* Second Layout */}
                <div className='card-border-sec' style={{
                    position: "relative", borderRadius: "8px",
                    border: `1px solid ${cardBorderColor}`, padding: '3rem 2rem', marginTop: "5rem"
                }}>
                    {/* General Text */}
                    <h3
                        className='subheading-sec-card'
                        style={{
                            position: "absolute",
                            top: "-10px",
                            left: "15px",
                            backgroundColor: backgroundCard,
                            padding: "0 10px",
                        }}
                    >
                        {t('franchise.contact')}
                    </h3>

                    <Grid container spacing={isTablet ? 2 : 10} >
                        <Grid id="franchise-items" item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* Email */}
                            <p className='label-text-sec'>{t('franchise.Email')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="someone@gmail.com"
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.email && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.email}
                                </Typography>
                            )}
                        </Grid>
                        <Grid  id="franchise-items" item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* PhoneNumber */}
                            <p className='label-text-sec'>{t('franchise.PhoneNumber')}*</p>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '6px',
                                    overflow: 'hidden',
                                    backgroundColor: inputBoxColor,
                                    height: '50px',
                                }}
                            >
                                <Autocomplete
                                    options={countryCodes}
                                    getOptionLabel={(option) => `${option.name} (${option.dial_code})`}
                                    value={countryCode}
                                    onChange={(e, newValue) => {
                                        if (newValue) {
                                            setCountryCode(newValue);
                                            setFormData(prev => ({
                                                ...prev,
                                                phoneNumber: `${newValue.dial_code} ${phoneNumber}`.trim(),
                                            }));
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option.dial_code === value.dial_code}
                                    sx={{
                                        minWidth: 125,
                                        '& .MuiInputBase-root': {
                                            height: '48px',
                                            borderRight: `1px solid ${cardBorderColor}`,
                                            borderRadius: 0,
                                            backgroundColor: 'transparent',
                                            px: '10px',
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            InputProps={{ ...params.InputProps, disableUnderline: true }}
                                        />
                                    )}
                                />
                                <InputBase
                                    placeholder={`${t('membershipCards.mobileNumber')} *`}
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        const digitsOnly = e.target.value.replace(/\D/g, '');
                                        setPhoneNumber(digitsOnly);
                                        if (errors.phoneNumber) setErrors(prev => ({ ...prev, phoneNumber: '' }));
                                        setFormData(prev => ({
                                            ...prev,
                                            phoneNumber: `${countryCode.dial_code} ${digitsOnly}`.trim(),
                                        }));
                                    }}
                                    sx={{ px: 2, flex: 1, height: '100%', color: textColor }}
                                />
                            </Box>

                            {errors.phoneNumber && (
                                <Typography color="error" variant="caption">
                                    {errors.phoneNumber}
                                </Typography>
                            )}
                        </Grid>
                        {mode1 === 'add' && (
                            <Grid  id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>
                                {/* Username */}
                                <p className='label-text-sec'>{t('loginPage.username')}*</p>
                                <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                    <InputBase
                                        name="userName"
                                        value={formData.userName}
                                        onChange={handleChange}
                                        // placeholder="someone@gmail.com"
                                        fullWidth
                                        sx={{
                                            fontSize: '14px',
                                            color: textColor,
                                            '&::placeholder': {
                                                color: '#9CA3AF',
                                            },
                                        }}
                                    />
                                </Box>
                                {errors.userName && (
                                    <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                        {errors.userName}
                                    </Typography>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </div>

                {/* machines Layout */}
                {mode1 === 'update' && (
                    <div className='card-border-sec' style={{
                        position: "relative", borderRadius: "8px",
                        border: `1px solid ${cardBorderColor}`, padding: '2rem', marginTop: "5rem"
                    }}>
                        {/* General Text */}
                        <h3
                            className='subheading-sec-card'
                            style={{
                                position: "absolute",
                                top: "-10px",
                                left: "15px",
                                backgroundColor: backgroundCard,
                                padding: "0 10px",
                            }}
                        >
                            {t('franchise.machines')}
                        </h3>

                        <Grid container>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                                <Grid  item xs={12} sm={6} md={3} className='stategrid5'>
                                    {/* Machines */}
                                    <p className='label-text-sec'>{t('franchise.NumberofMachines')}</p>
                                    <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                        <InputBase
                                            name="numberOfMachinesOwned"
                                            value={formData.numberOfMachinesOwned}
                                            onChange={handleChange}
                                            fullWidth
                                            disabled
                                            sx={{
                                                fontSize: '14px',
                                                color: textColor,
                                                opacity: 1,
                                                "& .MuiInputBase-input.Mui-disabled": {
                                                    color: textColor,
                                                    opacity: 1,
                                                },
                                            }}
                                        />
                                    </Box>
                                    {errors.numberOfMachinesOwned && (
                                        <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                            {errors.numberOfMachinesOwned}
                                        </Typography>
                                    )}
                                </Grid>
                                <Box sx={{ display: "inline-flex", justifyContent: "flex-end", alignSelf: "flex-end" }}>
                                    <ArrowButton targetRoute={`${ROUTES.VENDING_MACHINES}`} franchise={formData?.id ? "franchise" : ""} franchiseId={formData.id} />
                                </Box>
                            </Box>
                        </Grid>
                    </div>
                )}

                {/* Third Layout */}
                <div className='card-border-sec' style={{
                    position: "relative", borderRadius: "8px",
                    border: `1px solid ${cardBorderColor}`, padding: '3rem 2rem', marginTop: "5rem"
                }}>
                    {/* General Text */}
                    <h3
                        className='subheading-sec-card'
                        style={{
                            position: "absolute",
                            top: "-10px",
                            left: "15px",
                            backgroundColor: backgroundCard,
                            padding: "0 10px",
                        }}
                    >
                        {t('franchise.address')}
                    </h3>

                    <Grid container spacing={isTablet ? 2 : 10}  >
                        <Grid  id="franchise-items" item xs={12} sm={6} md={4} className='stategrid5 margin-top  '>
                            {/* Address1 */}
                            <p className='label-text-sec'>{t('franchise.Line1')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="addressLine1"
                                    value={formData.addressLine1}
                                    onChange={handleChange}
                                    placeholder={t('franchise.StreetAddress')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.addressLine1 && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.addressLine1}
                                </Typography>
                            )}
                              {/* State */}
                            <p className='label-text-sec'>{t('franchise.State')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    placeholder={t('franchise.Zurich')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.state && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.state}
                                </Typography>
                            )}
                        </Grid>
                        <Grid id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* Address2 */}
                            <p className='label-text-sec'>{t('franchise.Line2')}</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="addressLine2"
                                    value={formData.addressLine2}
                                    onChange={handleChange}
                                    placeholder={t('franchise.StreetAddress')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.addressLine2 && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.addressLine2}
                                </Typography>
                            )}

                               {/* Country */}
                            <p className='label-text-sec'>{t('franchise.Country')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    placeholder={t('franchise.Germany')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.country && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.country}
                                </Typography>
                            )}
                        </Grid>
                        <Grid id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* City */}
                            <p className='label-text-sec'>{t('franchise.City')}*</p>
                            <Box sx={{ border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem' }}>
                                <InputBase
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    placeholder={t('franchise.Zurich')}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.city && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.city}
                                </Typography>
                            )}
                             {/* Zip */}
                            <p className='label-text-sec'>{t('franchise.ZipPostal')}*</p>
                            <Box sx={{
                                border: 'none', borderRadius: '8px', backgroundColor: inputBoxColor, padding: '0.5rem 1rem', '& input[type=number]': {
                                    MozAppearance: 'textfield', // Firefox
                                },
                                '& input[type=number]::-webkit-outer-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                                '& input[type=number]::-webkit-inner-spin-button': {
                                    WebkitAppearance: 'none',
                                    margin: 0,
                                },
                            }}>
                                <InputBase
                                    type='number'
                                    name="zipCode"
                                    inputProps={{ min: 1 }}
                                    value={formData.zipCode}
                                    onChange={handleChange}
                                    placeholder="000000"
                                    onWheel={(e) => {
                                        e.target.blur()
                                    }}
                                    {...onlyPositiveNumberProps}
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': {
                                            color: '#9CA3AF',
                                        },
                                    }}
                                />
                            </Box>
                            {errors.zipCode && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.zipCode}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </div>

                {/* Last Layout */}
                <div className='card-border-sec' style={{
                    position: "relative", borderRadius: "8px",
                    border: `1px solid ${cardBorderColor}`, padding: '3rem 2rem', marginTop: "5rem"
                }}>
                    {/* General Text */}
                    <h3
                        className='subheading-sec-card'
                        style={{
                            position: "absolute",
                            top: "-10px",
                            left: "15px",
                            backgroundColor: backgroundCard,
                            padding: "0 10px",
                        }}
                    >
                        {t('franchise.agreementDetails')}
                    </h3>

                    <Grid container spacing={isTablet ? 2 : 10} >
                        {/* startDate */}
                        <Grid id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* Start Date */}
                            <p className='label-text-sec'>{t('franchise.StartDate')}</p>
                            <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem' }}>
                                <InputBase
                                    type="date"
                                    name="startDate"
                                    value={formData.startDate}
                                    onChange={handleChange}
                                    placeholder="Select Date"
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': { color: '#9CA3AF' },
                                    }}
                                    onClick={showDatePicker}
                                />
                            </Box>
                            {errors.startDate && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.startDate}
                                </Typography>
                            )}
                         <p className='machine-name-text website_document' style={{ margin: "3rem 0rem 0rem" }}>{t('franchise.Documents')}</p>

                        </Grid>
                        {/* endDate */}
                        <Grid id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* Start Date */}
                            <p className='label-text-sec'>{t('franchise.EndDate')}</p>
                            <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: inputBoxColor, borderRadius: '8px', padding: '0.5rem 1rem' }}>
                                <InputBase
                                    type="date"
                                    name="endDate"
                                    value={formData.endDate}
                                    onChange={handleChange}
                                    placeholder="Select Date"
                                    fullWidth
                                    sx={{
                                        fontSize: '14px',
                                        color: textColor,
                                        '&::placeholder': { color: '#9CA3AF' },
                                    }}
                                    onClick={showDatePicker}
                                />
                            </Box>
                            {errors.endDate && (
                                <Typography sx={{ color: errorTextColor, fontSize: '12px', marginTop: '2px' }}>
                                    {errors.endDate}
                                </Typography>
                            )}
                         <p className='machine-name-text mobile_document' style={{ margin: "3rem 0rem 0rem" }}>{t('franchise.Documents')}</p>

                        </Grid>
                    </Grid>

                   
                    <Grid container spacing={isTablet ? 2 : 10}>

                        <Grid id="franchise-items"  item xs={12} sm={6} md={4} className='stategrid5'>

                            {/* agreement document */}
                            <p className='label-text-sec'>{t('franchise.AgreementContract')}</p>
                            <FileUpload label="Agreement Contract" onFileUpload={handleFileUpload1} error={errors.agreementDocument} documentUrl={existingAgreementDocumentUrl} />
                        </Grid>
                        {/* <Grid  id="franchise-items" item xs={12} sm={6} md={4} className='stategrid5'>
                            terms and conditions
                            <p className='label-text-sec'>{t('franchise.TermsConditions')}</p>
                            <FileUpload label="Terms & Conditions" onFileUpload={handleFileUpload2} error={errors.termsConditions} documentUrl={existingtermsConditionsUrl} />
                        </Grid> */}
                        <Grid id="franchise-items" item xs={12} sm={6} md={4} className='stategrid5'>
                            {/* invoices */}
                            <p className='label-text-sec'>{t('franchise.Invoices')} </p>
                            <FileUpload label="Invoices" onFileUpload={handleFileUpload3} error={errors.invoiceDocument} documentUrl={existinginvoiceDocumentUrl} />
                        </Grid>
                    </Grid>
                </div>

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: '1vw' }}>
                    {mode1 !== 'add' && franchiseId &&
                        <button type="button" onClick={handleDeleteClick} style={{ color: errorTextColor, borderColor: errorTextColor, marginTop: 20 }} className='cancel-btn'>{t('membershipCards.delete')}</button>
                    }
                </Box>
            </Box>

            {/* Render the Modal */}
            <ConfirmationModal
                open={isModalOpen}
                onClose={handleModalClose}
                onSave={handleSaveChanges}
                onDiscard={handleDiscardChanges}
            />

            {/* Use Notification Component */}
            <SuccessNotification
                open={successNotification}
                message={successMessage}
                severity="success"
                onClose={() => setSuccessNotification(false)}
            />

            {/* Delete Confirmation Popup */}
            <DeleteConfirmationPopup
                open={isDeletePopupOpen}
                onClose={handleCloseDeletePopup}
                heading={t('franchise.deleteConfirmHeading')}
                message={hasMachines ? t('franchise.machineExistMessage') : t('franchise.deleteConfirmMessage')}
                onConfirm={handleConfirmDelete}
                errorMessage={deleteErrorMessage}
            />

        </div >
    )
}

export default FranchiseModal